import Swiper, { Autoplay, EffectFade, Pagination } from 'swiper';

/**
 * @class LabeledSlider
 *
 * Create a slider with a labeled pagination
 */
class LabeledSlider {
    constructor (el, labels) {
        console.log(labels)
        this.el = el;
        this.labels = labels;

        this.slider = new Swiper(this.el, {
            modules: [Autoplay, EffectFade, Pagination],
            autoplay: {
                delay: 5000
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                renderBullet: (i, className) => {
                    return '<span class="' + className + ' c-labeled-slider__label' + '">' + (this.labels[i]) + '</span>';
                },
                clickable: true
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            slidesPerView: 1,
            grabCursor: true
        });
    }
}

export default LabeledSlider;
